import { DiffBasketUtil } from '@shared/utils/DiffBasket'

import { computed } from 'vue'

import useContract from '@shared/hooks/useContract'
import usePersonDetails from '@shared/hooks/usePersonDetails'
import usePersonSpecificProduct from '@shared/hooks/usePersonSpecificProduct'
import { cloneDeep } from 'lodash'
import { PRODUCT_MODIFICATION_TYPE } from '@shared/config/constants'

// GLOBAL DATA
const MODE = {
  CHANGED: 'changed',
  EXISTING: 'existing',
}

export default function useDiffBasket() {
  // HOOKS
  const { contract, contractPersonsWithDetails } = useContract()
  const { personsWithDetails } = usePersonDetails()
  const { getSelectedProductsByCategory } = usePersonSpecificProduct()

  // COMPUTED
  const basketPersons = computed(() => {
    return personsWithDetails.value.filter(p => p.contractModified)
  })

  const contractPersons = computed(() => {
    return contractPersonsWithDetails.value.filter(p =>
      basketPersons.value.some(bp => bp.contractNumber === p.contractNumber)
    )
  })

  const diffPersons = computed(() => {
    return getDiffPersons(contractPersons.value, basketPersons.value)
  })

  const hasChangesInBasket = computed(() => {
    let hasChanges = false
    diffPersons.value?.forEach(person => {
      if (person.diffProducts.length > 0) {
        const newModifiedProducts = cloneDeep(person.diffProducts).filter(product => {
          return product.changed?.some(
            changedProduct => changedProduct.modificationType !== PRODUCT_MODIFICATION_TYPE.ORIGINAL
          )
        })
        if (newModifiedProducts.length > 0) {
          hasChanges = true
        }
      }
    })
    return hasChanges
  })

  // METHODS
  function fillCategories(currentCategories, person, mode) {
    const contractNumber = person.contractNumber
    getSelectedProductsByCategory(person.selectedProducts).forEach(category => {
      currentCategories = DiffBasketUtil.addCategoryToList(currentCategories, contractNumber, category, mode)
    })
  }

  function getDiffPersons(oldBasket, newBasket) {
    let personMap = new Map()
    let categories = {}

    newBasket.forEach(p => {
      fillCategories(categories, p, MODE.CHANGED)
      DiffBasketUtil.mapPerson(personMap, p, MODE.CHANGED)
    })

    oldBasket.forEach(p => {
      fillCategories(categories, p, MODE.EXISTING)
      DiffBasketUtil.mapPerson(personMap, p, MODE.EXISTING)
    })

    DiffBasketUtil.addSortedCategoriesToMap(personMap, categories)
    return [...personMap.values()]
  }

  function hasContractSameMasterTreaty(basketMasterTreaty) {
    return contract.masterTreaty === basketMasterTreaty
  }

  return {
    // Computed
    basketPersons,
    contractPersons,
    diffPersons,
    hasChangesInBasket,
    // Methods
    hasContractSameMasterTreaty,
  }
}
